  import React from "react";
import { combo2x1ProductsService } from "../../../shared/services";
import { notify } from "@/shared/utils/notify";
import { Iproducts2x1 } from "../../../redux/@types";

export const useUpdateStatusProduct2x1 = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);


  const updateStatus = async(value: "active" | "inactive", id: any) =>{
    if (isLoading) return;
    setIsLoading(true);
    await combo2x1ProductsService.patch(id,{
      status: value,
    })
    .then((res: Partial<Iproducts2x1>) => {
      setIsLoading(false);
        notify.success(
          `Se ha actualizado con éxito el estado del producto 2x1 con id:${res.id}`
        );
    })
    .catch((err: any) => {
      setIsLoading(false);
      notify.error(err.message);
    });
  }

  return {
    isLoading,
    updateStatus
  };
};
